import BaseView from '../../../views/base';
import HeadingTemplate from '../templates/heading.html';

const LayoutView = BaseView.extend({
    events: {
        'keypress .js-members-container': 'keyPressEvent',
    },

    initialize({ target, model, collection }) {
        this.target = target;
        this.model = model;
        this.libraries = collection;
        this.listenTo(this.libraries, 'sync', this.render);
        this.template = HeadingTemplate;
        this.renderLoader();
    },

    keyPressEvent(e) {
        if (
            (e.key === 'Enter' || e.key === ' ') &&
            $('.js-select-library').is(':focus')
        ) {
            e.preventDefault();
            e.stopPropagation();
        }
    },

    getTemplateData() {
        return {
            members: this.libraries.models,
        };
    },

    onClose() {
        this.undelegateEvents();
        this.target.removeData().unbind();
        this.target.empty();
    },
});

export default LayoutView;
